let map_data = [
/*
[50,68,67,61,53,49,46,45,49,58,61,61,60,48,53,43,46,42,53,51,55,60,65,71,77,67,62,59,69,58,40,22,39,33,32,54,59,50,59,67],
[68,83,82,73,63,50,45,44,44,42,44,48,47,44,42,38,33,41,37,41,50,51,56,58,81,74,71,62,65,59,44,34,38,46,45,48,49,53,57,71],
[67,74,79,83,71,61,60,60,56,56,45,38,43,38,38,40,33,34,25,35,33,45,52,49,65,67,68,62,64,59,49,38,32,41,49,47,47,45,58,67],
[57,68,69,66,62,61,70,69,66,64,54,40,50,43,49,47,50,52,39,27,29,38,37,46,52,54,54,55,57,66,50,38,36,39,35,32,38,40,57,66],
[53,54,55,55,62,64,75,63,63,65,52,47,54,45,55,53,51,58,55,41,42,32,39,52,59,47,55,53,55,65,55,51,36,44,42,30,32,43,57,57],
[52,52,50,57,65,64,63,59,61,56,51,42,54,54,58,58,59,63,59,59,48,35,40,51,63,59,57,58,53,62,60,60,54,52,54,43,43,41,46,51],
[39,49,50,50,50,52,47,37,42,49,43,52,61,65,62,63,64,73,69,72,58,39,36,55,61,65,50,51,62,59,57,54,61,54,71,65,58,49,46,55],
[39,39,43,47,42,35,29,34,40,45,48,67,69,58,61,53,58,78,79,67,56,45,40,49,64,58,47,52,53,58,43,46,50,61,68,77,65,60,53,57],
[50,43,41,40,37,42,37,46,48,58,50,73,70,60,50,52,57,66,69,59,47,47,40,40,53,54,34,45,52,59,51,42,48,64,71,79,76,63,64,71],
[57,58,55,46,40,47,52,51,50,60,61,70,70,54,49,67,71,71,66,56,40,32,29,29,39,40,35,45,45,43,44,39,46,53,66,78,73,72,79,77],
[68,70,57,55,45,55,56,54,67,66,63,67,61,49,53,50,61,68,55,55,43,33,20,29,38,38,34,37,41,45,44,43,50,56,62,70,62,65,74,69],
[59,62,62,59,57,55,58,58,54,60,63,53,51,53,30,36,52,50,54,47,36,23,17,25,34,37,36,36,41,49,44,39,49,57,61,66,64,61,70,65],
[48,53,60,58,57,58,53,55,54,52,59,47,49,41,29,30,38,48,48,34,27,25,35,44,44,46,47,42,42,46,45,34,48,53,63,60,58,65,73,64],
[46,52,48,49,63,58,59,63,59,60,47,32,37,33,27,32,46,55,50,35,37,37,49,58,58,43,40,47,51,42,35,27,36,47,61,69,70,65,64,60],
[40,42,39,38,46,53,56,52,53,52,44,38,32,32,39,44,44,54,42,34,34,54,62,64,59,46,34,45,42,36,24,26,30,42,64,59,64,57,48,48],
[40,32,33,34,42,46,40,50,52,51,44,44,40,47,43,50,51,47,47,31,36,43,57,70,56,50,46,34,32,18,17,16,23,39,42,39,54,54,39,28],
[49,36,37,36,37,44,45,40,47,59,64,64,56,61,68,64,58,56,58,39,27,42,64,69,59,55,45,34,31,30,30,21,28,39,37,42,43,46,35,25],
[50,39,36,44,42,52,48,41,44,61,74,78,73,70,68,71,55,51,49,43,29,46,64,73,69,54,45,37,31,46,43,39,46,55,48,39,38,44,39,27],
[48,52,54,61,54,48,44,45,40,46,62,76,77,74,67,65,48,48,45,36,33,48,52,64,61,48,44,31,41,66,71,64,65,66,55,51,48,45,45,39],
[54,59,58,63,58,42,42,40,33,42,55,68,71,63,55,57,56,40,43,26,24,36,55,62,57,48,38,45,65,73,71,67,63,75,70,67,55,57,59,50],
[61,59,68,63,44,49,42,38,29,44,57,71,64,57,54,64,64,52,44,30,31,48,47,56,52,49,46,49,64,53,50,57,57,63,63,52,45,55,63,60],
[48,53,63,64,46,38,32,40,32,41,55,56,58,53,55,56,51,45,32,37,41,52,46,49,57,65,67,52,43,44,46,50,56,56,53,47,46,55,70,60],
[43,35,49,57,48,47,39,37,36,36,39,45,51,48,47,37,29,28,33,39,39,45,34,43,50,71,73,58,34,32,38,46,54,50,45,56,60,65,65,63],
[40,31,32,47,50,43,41,36,44,46,45,34,31,34,35,31,28,28,33,41,42,41,36,50,58,60,67,57,43,31,31,44,34,42,53,67,62,57,54,49],
[31,30,38,40,47,39,38,36,35,41,42,46,37,39,40,37,34,30,27,36,48,40,42,55,67,68,68,63,46,28,37,42,36,36,50,62,59,53,45,44],
[32,38,47,36,33,22,27,40,53,50,52,57,54,49,54,46,43,46,44,41,42,35,37,54,66,71,68,60,46,37,40,47,42,37,55,66,64,53,46,36],
[39,47,46,40,35,32,35,49,62,64,55,57,57,67,65,59,55,53,59,47,42,38,30,40,58,62,62,55,45,47,40,49,52,53,66,60,64,51,45,43],
[45,46,46,45,35,38,40,50,52,68,54,68,67,64,64,67,61,55,61,53,44,36,38,47,51,60,57,56,55,58,42,39,49,68,72,65,57,44,35,37],
[38,40,39,38,34,33,33,42,50,64,64,58,68,54,55,54,52,51,51,50,44,37,48,49,50,51,54,55,56,52,49,43,38,46,59,53,46,39,39,29],
[37,28,27,27,27,29,34,41,47,63,56,48,54,60,56,52,54,46,44,46,42,38,49,38,39,50,58,58,52,48,46,30,34,36,48,55,56,44,32,22],
[40,28,29,31,37,41,44,46,60,69,65,47,45,56,57,60,52,46,46,39,34,47,47,44,50,56,64,58,43,43,43,40,40,36,40,47,55,57,32,25],
[46,43,41,50,46,53,57,44,53,65,72,66,55,60,43,45,44,50,50,40,39,50,54,61,57,63,63,67,60,48,43,41,41,48,53,59,75,73,49,35],
[53,43,36,43,47,51,53,48,57,67,66,70,59,56,37,27,37,45,50,57,55,53,61,58,53,63,64,73,70,54,55,47,46,47,57,74,80,76,54,32],
[49,38,29,33,45,52,50,54,52,67,73,74,68,51,36,32,31,30,48,59,64,64,69,67,59,57,61,64,56,50,50,50,42,50,51,56,68,74,60,39],
[43,42,28,23,31,44,56,61,56,66,77,73,65,47,39,39,29,37,47,53,61,71,67,67,62,55,58,64,55,53,59,45,36,44,46,44,63,71,65,52],
[31,38,41,33,37,42,58,60,57,60,68,62,64,45,40,39,32,31,37,43,53,63,64,61,60,61,65,57,56,64,64,47,35,36,48,52,55,63,62,50],
[26,27,36,31,45,51,67,71,62,67,59,56,55,57,53,41,31,18,23,34,38,44,56,62,60,56,59,53,48,56,47,31,22,27,40,45,54,50,50,44],
[33,28,32,32,44,46,62,67,64,55,47,39,53,62,54,41,24,24,24,30,38,41,56,61,60,61,56,46,39,42,47,27,27,27,25,32,47,50,29,34],
[31,30,38,31,36,40,54,60,55,36,41,42,55,62,56,46,35,30,35,40,40,53,50,55,53,44,39,33,28,34,38,43,43,38,25,26,48,49,26,25],
[46,41,38,39,44,51,54,45,31,29,44,50,62,63,58,53,43,41,50,50,53,61,54,47,52,43,48,33,31,37,48,68,70,66,48,34,41,31,27,21],
*/
/*
[50,26,23,23,28,36,28,25,31,39,43,38,29,27,29,28,44,51,58,55,64,71,56,47,41,38,40,47,45,49],
[46,37,40,38,45,35,28,31,39,41,41,25,19,26,33,35,50,55,65,60,72,62,51,31,42,47,49,37,44,38],
[42,40,43,51,60,56,51,54,56,43,28,17,19,30,32,40,54,66,62,57,66,53,40,25,31,37,42,45,47,40],
[45,48,41,51,59,57,67,71,63,49,43,33,36,42,47,55,63,65,54,44,44,41,30,17,16,33,40,48,40,39],
[36,37,45,46,55,52,64,71,68,56,51,42,42,51,57,65,68,72,56,45,41,37,27,20,35,47,49,51,37,36],
[32,45,54,47,54,52,58,61,57,41,42,42,50,56,60,65,66,57,56,53,42,43,45,32,47,61,62,44,36,38],
[43,51,54,50,40,44,49,54,51,44,38,37,56,68,70,63,65,60,55,63,61,59,54,56,61,69,62,50,51,39],
[35,36,33,40,43,37,38,48,36,33,34,43,54,62,78,66,73,73,66,65,69,71,64,53,52,54,54,47,54,41],
[28,26,30,36,40,29,31,38,40,30,26,43,49,60,67,62,69,68,61,57,68,64,62,65,58,53,60,45,49,38],
[30,26,42,55,53,38,27,44,49,30,31,44,53,59,61,53,54,59,50,52,59,66,65,61,58,59,55,44,47,38],
[29,32,51,62,60,45,37,42,46,45,40,46,50,56,57,56,56,57,32,35,44,52,46,57,55,57,50,48,38,33],
[50,57,64,69,71,59,48,37,31,34,43,48,46,47,62,58,57,52,38,41,32,36,30,45,54,52,53,48,44,32],
[59,61,72,67,70,62,56,39,34,31,43,50,54,54,63,61,56,50,42,32,32,26,27,47,55,52,64,57,53,53],
[54,54,56,63,59,53,57,51,52,42,43,54,55,61,63,51,50,48,42,28,27,31,36,49,50,51,59,66,78,67],
[50,54,51,45,39,46,48,54,55,49,48,49,50,68,68,45,39,33,28,18,27,36,36,46,48,48,52,60,75,64],
[39,48,39,26,29,33,34,41,45,48,50,53,52,66,61,43,43,33,31,16,19,32,37,41,47,50,46,64,68,56],
[39,43,32,38,34,31,41,47,54,41,37,34,44,61,57,55,55,48,30,24,15,25,40,44,39,49,51,59,60,50],
[41,30,23,38,45,40,51,57,57,47,46,34,38,51,62,63,69,61,36,30,21,27,42,41,42,54,60,52,55,53],
[38,24,26,40,47,53,67,69,67,54,44,40,29,41,66,73,76,55,35,38,31,39,45,47,50,56,50,55,51,47],
[23,21,32,38,46,55,55,62,68,64,51,37,25,44,67,75,75,61,52,47,47,42,43,45,50,42,55,53,43,50],
[27,26,23,37,47,52,60,59,58,43,36,31,30,42,50,64,68,65,69,65,54,53,53,44,43,33,41,36,39,46],
[45,42,45,39,57,51,57,60,61,40,37,38,33,35,43,40,57,64,66,64,59,51,48,42,32,26,24,26,38,37],
[56,55,58,58,58,54,59,62,64,53,47,47,36,36,30,28,36,48,50,55,64,62,58,45,32,27,19,31,44,43],
[63,69,72,70,65,66,60,71,69,52,49,47,39,32,26,23,35,40,45,44,56,66,61,49,44,37,29,37,44,42],
[70,67,61,72,73,55,57,76,63,53,50,47,48,36,29,27,38,47,44,49,65,66,62,57,48,38,31,38,46,45],
[69,54,56,70,65,53,53,68,69,62,49,48,56,43,39,39,47,51,59,63,64,68,69,55,44,37,30,31,33,40],
[63,50,53,62,52,45,63,66,54,52,45,53,58,55,57,67,71,63,61,56,60,75,69,51,52,50,51,47,50,39],
[52,57,62,68,58,58,58,58,51,47,42,50,60,70,72,77,73,66,64,55,59,76,61,45,52,66,70,57,59,45],
[69,63,67,63,59,51,47,40,35,34,50,48,52,60,66,66,74,71,66,54,63,71,56,44,45,53,70,65,70,46],
[55,66,61,49,41,37,39,34,33,40,47,40,49,52,52,52,54,67,60,57,61,70,58,57,49,54,65,65,67,44],
*/
[50,31,32,39,47,50,57,56,57,55,44,51,43,45,35,37,34,34,32,23,18,32,43,48,43,52,62,56,55,61],
[48,34,26,34,39,52,58,51,55,49,56,55,56,44,37,35,35,29,24,24,38,47,46,44,61,51,62,66,64,68],
[46,40,37,31,31,43,47,55,46,51,57,65,57,39,33,26,35,34,22,33,42,53,52,58,68,70,62,64,62,61],
[41,38,40,37,37,38,50,47,48,55,60,62,50,35,33,40,36,41,33,34,47,59,64,72,75,62,56,55,52,55],
[44,49,45,47,50,35,41,33,38,54,56,57,55,56,62,49,36,38,38,40,48,57,66,72,63,57,45,42,50,53],
[39,38,44,52,52,47,41,35,45,59,62,65,72,68,66,57,44,56,52,53,46,56,55,56,41,33,27,35,42,47],
[37,36,38,57,51,62,49,44,53,54,56,69,78,71,65,53,57,64,58,61,53,59,50,39,33,20,20,26,38,58],
[38,43,55,65,66,60,56,54,60,61,58,65,68,56,51,49,47,58,60,52,53,49,38,30,25,18,27,38,57,69],
[50,54,61,60,54,65,64,70,74,53,50,63,62,48,43,44,44,58,57,43,41,40,30,34,26,32,42,54,76,78],
[50,51,47,50,44,53,71,69,75,53,50,57,47,36,39,45,56,57,63,48,43,35,34,42,44,48,55,60,77,73],
[48,45,39,37,48,57,64,64,67,61,61,56,49,32,34,42,49,61,64,54,52,36,41,44,49,45,50,56,64,76],
[52,43,39,36,40,56,62,54,56,60,68,56,40,31,32,51,54,59,61,56,53,40,45,53,53,47,51,57,62,68],
[45,44,35,23,30,54,63,61,48,53,70,61,44,29,34,47,53,52,51,54,41,36,53,56,64,53,54,58,54,55],
[39,43,28,30,38,56,65,75,65,62,67,58,42,29,32,39,46,46,45,45,50,47,41,55,68,57,55,48,42,47],
[39,41,41,52,58,69,70,69,65,59,48,41,39,34,38,51,54,54,58,58,51,45,56,61,58,50,36,30,30,31],
[49,52,52,56,73,77,65,61,49,56,55,38,34,49,53,61,69,52,52,54,42,46,63,75,65,52,36,32,27,23],
[49,53,56,56,67,71,58,43,36,41,50,38,47,54,60,66,74,54,37,36,35,42,63,72,64,53,38,33,29,26],
[40,44,51,52,55,69,58,39,29,32,42,48,56,61,66,66,68,63,33,22,27,43,60,64,50,48,38,33,38,46],
[37,49,47,51,46,53,50,39,28,29,36,48,66,69,61,59,73,51,31,27,33,44,57,62,48,42,32,33,38,40],
[36,43,43,50,47,48,40,34,37,40,39,46,73,64,59,62,58,51,42,45,39,35,54,58,50,47,40,32,35,43],
[33,37,45,47,48,43,44,44,56,63,62,63,65,63,57,58,58,51,43,53,48,47,52,59,57,45,35,36,41,48],
[43,43,42,47,55,54,56,58,60,69,70,76,64,52,52,54,53,35,35,57,54,51,46,55,42,42,32,36,45,58],
[53,55,57,60,64,61,59,48,55,64,71,78,69,48,42,38,36,26,38,51,59,60,51,40,39,40,39,41,43,55],
[50,63,62,72,68,55,47,38,47,65,69,79,73,52,47,36,27,17,22,37,56,62,58,50,40,34,41,51,53,54],
[54,63,74,74,65,49,36,25,34,48,63,69,67,58,50,31,17,16,24,43,63,67,61,60,47,31,34,42,50,55],
[55,68,72,71,58,48,35,30,33,36,57,63,62,73,62,48,32,30,34,51,67,66,61,61,46,30,24,31,30,38],
[48,61,73,58,45,41,38,39,32,38,50,65,56,70,71,67,49,41,44,46,61,59,56,52,43,26,31,40,38,36],
[54,59,59,49,50,49,53,46,43,47,50,56,50,58,72,73,57,52,46,39,41,42,41,43,35,38,37,42,34,45],
[45,61,58,56,56,55,60,59,52,53,56,52,54,63,57,52,55,60,50,42,33,25,27,22,34,39,32,35,37,54],
[46,62,70,64,62,59,60,66,64,70,65,51,56,57,52,45,52,64,56,43,48,33,26,17,26,28,40,32,38,53],
  ];

export function map() {
  // clear edges
  let data = map_data.map(function (row, ridx) {
    return row.map(function (v, idx) {
      if (idx === 0 || idx === row.length-1) {
        return false;
      }
      if (ridx === 0 || ridx === map_data.length - 1) {
        return false;
      }
      return v > 58 ? 'land' : null;
    });
  });
  // no tiny islands
  let island_size = data.map(function () {
    return [];
  });
  function count(x, y) {
    let search = [[x,y]];
    let done = [];
    while (search.length) {
      let s = search.pop();
      x = s[0];
      y = s[1];
      if (island_size[x][y]) {
        continue;
      }
      if (!data[x][y]) {
        continue;
      }
      island_size[x][y] = -1;
      done.push(s);
      search.push([x+1,y]);
      search.push([x-1,y]);
      search.push([x,y+1]);
      search.push([x,y-1]);
    }
    let r = done.length;
    for (let ii = 0; ii < done.length; ++ii) {
      island_size[done[ii][0]][done[ii][1]] = r;
    }
    return r;
  }
  function fill(x, y, v) {
    let match = data[x][y];
    let search = [[x,y]];
    while (search.length) {
      let s = search.pop();
      x = s[0];
      y = s[1];
      if (data[x][y] !== match) {
        continue;
      }
      data[x][y] = v;
      search.push([x+1,y]);
      search.push([x-1,y]);
      search.push([x,y+1]);
      search.push([x,y-1]);
    }
  }
  for (let ii = 1; ii < data.length - 1 ; ++ii) {
    for (let jj = 1; jj < data[ii].length - 1; ++jj) {
      if (data[ii][jj]) {
        if (!island_size[ii][jj]) {
          let c = count(ii, jj);
          if (c <= 5) {
            fill(ii, jj, null);
          }
        }
      }
    }
  }

  // no diagnols
  for (let ii = 1; ii < data.length - 1 ; ++ii) {
    for (let jj = 1; jj < data[ii].length - 1; ++jj) {
      if (data[ii][jj] && data[ii+1][jj+1] &&
        !data[ii+1][jj] && !data[ii][jj+1]) {
        data[ii+1][jj] = 'land';
      }
      if (data[ii+1][jj] && data[ii][jj+1] &&
        !data[ii][jj] && !data[ii+1][jj+1]) {
        data[ii+1][jj+1] = 'land';
      }
    }
  }

  // place ports
  [
  [23,20],
  [16,22],
  [2,23],
  [7,7],
  [23,2],
  [19,12],
  ].forEach(function (p) {
    data[p[0]][p[1]] = 'port';
  });

  return data;
}
